import React from "react";
import { ContactBtn } from "../../components/Buttons";
import softwareMobileImg from "../../../images/svgs/football-club-mobile.svg";
import softwareDesktopImg from "../../../images/svgs/football-club-desktop.svg";

const HomeSplash = () => {
    return(
        <section className="row gap-2 pt-1">
            <article className="container">
                <div className="col-12-xs col-6-md col-8-lg">
                    <div className="card">
                        <h5>Sports Management Software</h5>
                        <h1 className="animated-text">Unlock the Power of Your Sports Club...</h1>
                        <h4>Effortlessly manage your club without the need to juggle multiple apps or waste hours on boring administrative tasks.</h4>
                        <ContactBtn/>
                    </div>
                </div>
                <div className="col-12-xs col-6-md col-4-lg">
                    <div className="card">
                        <div className="tablet-view">
                            <img src={softwareMobileImg} alt="" className="mobile-img"/>
                            <img src={softwareDesktopImg} alt="" className="desktop-img"/>
                        </div>
                    </div>
                </div>
            </article>
        </section>
    )
}

export default HomeSplash;